import api from '@/utils/api';

/**
 * Get a Dealer Product
 * @param {string} dealerId - Query to filter dealer
 * @param {string} productId - The product id
 * @returns {Promise}
 */
const getDealerProductApi = (dealerId, productId) =>
  api.get(`dealer/${dealerId}/product/${productId}`);

export default getDealerProductApi;
